import { useQuery } from "@apollo/client";
import { Select, SelectProps } from "antd";
import { OFFICE_LOCATIONS_QUERY } from "~/graphql/query";
import React from "react";

export const OfficeLocationSelect = (props: SelectProps) => {
  const { data: officeLocations, loading: officeLocationsLoading } =
    useQuery(OFFICE_LOCATIONS_QUERY);

  return (
    <Select
      options={officeLocations?.officeLocations.map((x) => ({
        label: x.name,
        value: x.id,
      }))}
      loading={officeLocationsLoading}
      allowClear
      onChange={(value) => {
        console.log(value);
      }}
      showSearch
      {...props}
    />
  );
};
